import React from 'react';
import {
  ItCheckSection,
  Container,
  Title,
  Sub,
  DocsGrid,
  DocCard,
  DocIcon,
  DocTitle,
  DocActions,
  DocLink,
  CTAWrapper
} from './ItCheckElements';

import { Button } from '../ButtonElement';
import FlyerPDF from '../../assets/pdfs/Gratis_IT_Check_Flyer.pdf';
import AblaufPDF from '../../assets/pdfs/Ablauf_IT_Check.pdf';


const ItCheck = () => {
  return (
    <ItCheckSection id="itcheck">
      <Container>
        <Title>Gratis IT-Check</Title>
        <Sub>
          Holen Sie sich kostenlos und unverbindlich einen Überblick über Ihre IT-Infrastruktur.
          Laden Sie Flyer und Ablaufbeschreibung herunter – oder fordern Sie gleich Ihren persönlichen IT-Check an.
        </Sub>

        <DocsGrid>
          <DocCard>
            <DocIcon>📄</DocIcon>
            <DocTitle>Flyer – Gratis IT-Check</DocTitle>
            <DocActions>
              <DocLink href={FlyerPDF} target="_blank" rel="noopener noreferrer">Ansehen</DocLink>
              <DocLink href={FlyerPDF} download>Download</DocLink>
            </DocActions>
          </DocCard>

          <DocCard>
            <DocIcon>🧭</DocIcon>
            <DocTitle>Ablauf – So funktioniert’s</DocTitle>
            <DocActions>
              <DocLink href={AblaufPDF} target="_blank" rel="noopener noreferrer">Ansehen</DocLink>
              <DocLink href={AblaufPDF} download>Download</DocLink>
            </DocActions>
          </DocCard>
        </DocsGrid>

        <CTAWrapper>
          {/* Bestehender Button-Stil, scrollt sauber zum Kontaktformular */}
          <Button to="contact" smooth={true} duration={500} spy={true} offset={-80} primary="true" dark="true">
            Jetzt IT-Check anfragen
          </Button>
        </CTAWrapper>
      </Container>
    </ItCheckSection>
  );
};

export default ItCheck;
